<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="700px"
    @close="$router.replace('/users')"
    :close-on-click-modal="false"
  >
    <div v-loading="loading">
      <el-tabs
        v-model="selectedTab"
        tab-position="top"
      >
        <el-tab-pane
          label="Alapadatok"
          name="basicData"
        >
          <basic-data-form
            ref="basicDataForm"
            :error-data="errors"
            :dialog-type="type"
            :user="user"
            @add="add"
          />
        </el-tab-pane>
        <el-tab-pane
          label="HR Adatok"
          name="hrData"
        >
          <hr-data-form
            ref="hrForm"
            :user="user"
            @add="add"
          />
        </el-tab-pane>
        <el-tab-pane
          label="Cím adatok"
          name="addressData"
        >
          <address-data-form
            ref="addressDataForm"
            :address="user.address"
            @add="add"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/users')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        @click="add"
        :loading="buttonLoading"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import BasicDataForm from './forms/BasicData';
  import HrDataForm from './forms/HrForm';
  import AddressDataForm from './forms/AddressForm';

  export default {
    components: {
      BasicDataForm,
      HrDataForm,
      AddressDataForm,
    },
    props: ['type', 'userId'],
    data() {
      return {
        errors: {
          username: null,
        },
        selectedTab: 'basicData',
        loading: false,
        buttonLoading: false,
        user: {
          categories: [],
          storage_access: [],
          address: {}
        },
      };
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új felhasználó';
        } else if (this.type === 'update') {
          return 'Felhasználó módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadása';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
      loggedInUser() {
        return this.$store.getters['auth/user'];
      },
    },
    methods: {
      async add() {
        this.$refs['basicDataForm'].$refs['basicDataForm'].validate(async valid => {
          if (valid) {
            this.$refs['addressDataForm'].$refs['addressForm'].validate(async valid => {
              const send_address = this.$refs['addressDataForm'].has_address;
              if(valid || !send_address) {
                this.buttonLoading = true;
                const data = {
                  ...this.$refs['basicDataForm'].basicData,
                  ...this.$refs['hrForm'].hrData,
                  address: send_address ? this.$refs['addressDataForm'].addressData : null,
                };
                try {
                  if (this.type === 'add') {
                    await this.$store.dispatch('user/create', data);
                  } else if (this.type === 'update') {
                    await this.$store.dispatch('user/update', data);
                  }

                  this.$store.dispatch('user/fetchAllWithPagination');
                  if (this.loggedInUser.id === this.user.id) {
                    this.$store.dispatch('auth/fetchUser');
                  }
                  this.buttonLoading = false;
                  this.$router.replace('/users');
                } catch (e) {
                  this.buttonLoading = false;
                  if (e.data && e.data.errors) {
                    this.errors = e.data.errors;
                  }
                }
              } else {
                this.selectedTab = 'addressData';
              }
            });
          } else {
            this.selectedTab = 'basicData';
          }
        });
      },
    },
    async mounted() {
      this.loading = true;
      await Promise.all([
        this.$store.dispatch('userCategory/fetchAll'),
        this.$store.dispatch('role/fetchAll'),
        this.$store.dispatch('invoiceBook/fetchAll'),
        this.$store.dispatch('location/fetchAll'),
        this.$store.dispatch('user/fetchAll'),
        this.$store.dispatch('country/fetchAll'),
        this.$store.dispatch('county/fetchAll'),
      ]);
      this.$refs['basicDataForm'].$refs['basicDataForm'].clearValidate();
      if (this.userId) {
        this.user = await axios.get(`api/users/${this.userId}`);
        this.user = {
          ...this.user,
          roles: this.user.roles.map(r => r.id),
          categories: this.user.categories.map(c => c.id),
          invoice_books: this.user.invoice_books.map(r => r.id),
          locations: this.user.locations.map(l => l.id),
          storage_access: this.user.storage_access.map(l => l.id),
        };
      }
      this.loading = false;
    },
  };
</script>
